<template>
<div>
    <div class="header_fixed">
        <div class="color_header" :style="{background: bg_color}">
            <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center">
                    <div class="logo_header">
                        <img :src="beforeImage">
                    </div>
                    <div class="pl-2 color_title_header">
                        <div v-if="$route.name != 'orderOnlinePickUp'">{{ $route.name == 'takeOutUser' ? $store.state.cartTakeOutNameUser : $route.name != 'takeOutUser' ? $t('table')+' '+ table_name : ''}}</div>
                        <div v-if="$route.name != 'orderOnlinePickUp'">{{ $route.name == 'buffetUser' ? $t('buffet') : $route.name == 'singleDishMealUser' ? $t('dineAtRestaurant') : $route.name == 'takeOutUser' || $route.name == 'takeOutUserTable' ? $t('takehome') : '' }}</div>
                        <div v-if="$route.name == 'orderOnlinePickUp'">{{ $store.state.cartOrderOnlineNameUser.name }}</div>
                        <div v-if="$route.name == 'orderOnlinePickUp'">{{ $t('pickup') }} {{ $store.state.cartOrderOnlineNameUser.time }}</div>
                    </div>
                </div>
                <div class="d-flex">
                    <div>
                        <img class="mr-2" v-if="selectedLanguage == 'en'" src="../../../public/eng.png" @click="changeLanguage('en')"  />
                        <img class="mr-2" v-if="selectedLanguage == 'th'" src="../../../public/eng_gray.png" @click="changeLanguage('en')"/>
                        <img class="mr-2" v-if="selectedLanguage == 'th'" src="../../../public/th.png"  @click="changeLanguage('th')" />
                        <img class="mr-2" v-if="selectedLanguage == 'en'" src="../../../public/th_gray.png" @click="changeLanguage('th')" />
                    </div>
                    <div class="cart_all_header" @click="openTakeOutTable()" v-if="$route.name == 'buffetUser' && cart_type || $route.name == 'singleDishMealUser' && cart_type">
                        <div class="img_cart_header">
                            <img src="@/assets/take-away1.png">
                        </div>
                    </div>

                    <div class="cart_all_header" @click="$router.push('/myorder/'+ cart_type+'/'+$route.params.token)" v-if="$route.name == 'buffetUser' && cart_type || $route.name == 'singleDishMealUser' && cart_type">
                        <div class="img_cart_header">
                            <img src="@/assets/spoonandforkcircle.png">
                        </div>
                    </div>

                    <!-- <div class="cart_all_header" @click="$router.push('/cartmenu/'+ cart_type+'/'+$route.params.token)" v-if="$route.name == 'buffetUser' && cart_type || $route.name == 'singleDishMealUser' && cart_type">
                        <div class="img_cart_header">
                            <img src="@/assets/shopping-cart.png">
                        </div>
                        <div class="cart_number_header">
                            <div>{{ $store.state.cartListUser.length }}</div>
                        </div>
                    </div> -->

                    <!-- <div class="cart_all_header" @click="$router.push('/carttakeouttable/'+$route.params.token)" v-if="$route.name == 'takeOutUserTable'">
                        <div class="img_cart_header">
                            <img src="@/assets/shopping-cart.png">
                        </div>
                        <div class="cart_number_header">
                            <div>{{ $store.state.cartListTakeOutTable.length }}</div>
                        </div>
                    </div> -->
                    <div class="cart_all_header" @click="open_outtakeoutuser = true" v-if="$route.name == 'takeOutUser'">
                        <div class="img_cart_header">
                            <img src="@/assets/log-out.png">
                        </div>
                    </div>
                    <div class="cart_all_header" @click="open_outtakeoutuser = true" v-if="$route.name == 'orderOnlinePickUp'">
                        <div class="img_cart_header">
                            <img src="@/assets/log-out.png">
                        </div>
                    </div>
                    <!-- <div class="cart_all_header" @click="$router.push('/carttakeoutuser')" v-if="$route.name == 'takeOutUser'">
                        <div class="img_cart_header">
                            <img src="@/assets/shopping-cart.png">
                        </div>
                        <div class="cart_number_header">
                            <div>{{ $store.state.cartListUserTakeOut.length }}</div>
                        </div>
                    </div> -->
                </div>

            </div>
        </div>
        <div>
            <v-tabs grow :color="bg_color">
                <v-tab @click="page('buffet');" v-if="$route.name == 'buffetUser'">{{ $t('buffet') }}</v-tab>
                <v-tab @click="page('alacarte');">{{ $t('alacarte') }}</v-tab>
            </v-tabs>
        </div>
    </div>
    <!-- ไอคอนที่มุมขวาล่าง -->
    <v-tooltip open-on-click left>
        <template v-slot:activator="{ on, attrs }">
            <div class="floating-icon" v-bind="attrs" v-on="on" @click="openDialog = true">
            <v-icon large color="blue">mdi-account-alert</v-icon>
            </div>
        </template>
        <span>{{ $t('callstaff') }}</span>
    </v-tooltip>



    <!-- Popup (v-dialog) -->
    <v-dialog v-model="openDialog" persistent max-width="400">
      <v-card>
        <v-card-title>
          <span class="text-h6" style="font-family: Kanit, sans-serif !important;">{{ $t('confirmAction') }}</span>
          <v-spacer></v-spacer>
          <v-icon @click="openDialog = false" class="cursor-pointer">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <p>{{ $t('confirmMessage') }}</p>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="grey" @click="openDialog = false">{{ $t('close') }}</v-btn>
          <v-btn text color="primary" @click="handleConfirm($route.params.token)">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Popup (v-dialog) -->
    <v-dialog v-model="openDialogSuccess" persistent max-width="400">
      <v-card>
        <v-card-title>
          <span class="text-h6" style="font-family: Kanit, sans-serif !important;">{{ $t('confirmMessageSuccess') }}</span>
          <v-spacer></v-spacer>
          <v-icon @click="openDialogSuccess = false" class="cursor-pointer">mdi-close</v-icon>
        </v-card-title>
        <!-- <v-card-text>
          <p>{{ $t('confirmMessageSuccess') }}</p>
        </v-card-text> -->
        <v-card-actions>
          <v-btn text color="grey" @click="openDialogSuccess = false">{{ $t('close') }}</v-btn>
          <!-- <v-btn text color="primary" @click="handleConfirm($route.params.token)">{{ $t('submit') }}</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Popup (v-dialog) -->
    <v-dialog v-model="openDialogFail" persistent max-width="400">
      <v-card>
        <v-card-title>
          <span class="text-h6" style="font-family: Kanit, sans-serif !important;">{{ $t('confirmMessageFail') }}</span>
          <v-spacer></v-spacer>
          <v-icon @click="openDialogFail = false" class="cursor-pointer">mdi-close</v-icon>
        </v-card-title>
        <!-- <v-card-text>
          <p>{{ $t('confirmMessageFail') }}</p>
        </v-card-text> -->
        <v-card-actions>
          <v-btn text color="grey" @click="openDialogFail = false">{{ $t('close') }}</v-btn>
          <!-- <v-btn text color="primary" @click="handleConfirm($route.params.token)">{{ $t('submit') }}</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="open_outtakeoutuser" persistent max-width="600">
        <v-card>
            <v-card-title class="justify-space-between">
                <div>{{ $t('confirmCancel') }} </div>
                <div class="cursor_icon_header" @click="open_outtakeoutuser = false">
                    <v-icon>mdi-close</v-icon>
                </div>
            </v-card-title>

            <v-card-text>
                .
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="outTakeOutUser()">
                    {{ $t('yes') }}, {{ $t('iWantCancel') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import Vue from 'vue';
import before_image from "@/assets/new_logo_by.png";
import VueI18n from 'vue-i18n';
import store from '@/store'; // นำเข้า Vuex store
Vue.use(VueI18n);
const messages = {
  en: {
    buffet :'buffet',
    alacarte: 'A LA CARTE',
    drink: 'drink',
    warning: 'Warning!',
    submit: 'Submit',
    close: 'Close',
    ok: 'OK',
    dineAtRestaurant: 'Eat here',
    takehome: 'Take away',
    table: 'Table',
    pickup: 'Pick up at restaurant',
    confirmCancel: 'Confirm cancel order ?',
    yes:'Yes',
    no:'No',
    iWantCancel :'I want to cancel',
    confirmMessage :'Call a staff member to your table',
    confirmMessageSuccess: 'Staff has been called successfully. Please wait a moment.',
    confirmMessageFail: 'The staff is on the way. Please try calling again later.',
    confirmAction :'Are you sure you want to call a staff member?',
    callstaff :'Press to call staff',
  },
  th: {
    buffet : 'บุฟเฟ่ต์',
    alacarte: 'A LA CARTE',
    drink: 'เครื่องดื่ม',
    warning: 'คำเตือน!',
    ok: 'ตกลง',
    close: 'ปิด',
    submit: 'ยืนยัน',
    dineAtRestaurant: 'ทานที่ร้าน',
    takehome: 'ซื้อกลับบ้าน',
    table: 'โต๊ะ',
    pickup: 'รับเองที่ร้าน',
    confirmCancel: 'ยกเลิกการสั่งซื้อใช่หรือไม่ ?',
    yes:'ใช่',
    no:'ไม่',
    iWantCancel :'ฉันต้องการยกเลิก',
    confirmMessage :'เรียกพนักงานมาที่โต๊ะของคุณ',
    confirmMessageSuccess :'เรียกพนักงานสำเร็จ กรุณารอสักครู่',
    confirmMessageFail :'พนักงานกำลังมา กรุณาลองเรียกอีกครั้ง',
    confirmAction :'ยืนยันการเรียกพนักงานหรือไม่',
    callstaff :'กดเพื่อเรียกพนักงาน',

  },
 
};
const i18n = new VueI18n({
  locale: store.state.lang, // กำหนดภาษาหลัก
  messages,
});
export default {
    i18n,
    data() {
        return {
            openDialog: false, // ควบคุมการแสดงผลของ Popup
            openDialogSuccess: false, // ควบคุมการแสดงผลของ Popup
            openDialogFail: false, // ควบคุมการแสดงผลของ Popup
            beforeImage: before_image,
            bg_color: 'linear-gradient(to top, #038cc1 , #55c0e9)',
            title: this.$route.name == 'buffetUser' ? 'buffet' : 'alacarte',
            cart_type: null,
            open_outtakeoutuser: false,
            selectedLanguage: store.state.lang || 'en',
        }
    },
    props: ['table_name', 'table_type', 'table_detail'],
    methods: {
        async handleConfirm(token) {
            this.loading = true; // เปิดสถานะโหลด (ปุ่มจะถูกปิดไม่ให้กดซ้ำ)
            try {
                // เรียก API พร้อมส่ง token
                const response = await HTTP.get(`/customer/updateCallEmp_customer/${token}`); 
                if (response.data.successful) {
                    this.openDialog = false; // ปิด dialog
                    this.openDialogSuccess = true; // ปิด dialog
                } else {
                    this.openDialog = false; // ปิด dialog
                    this.openDialogFail = true; // ปิด dialog
                }
            } catch (error) {
                console.error('เกิดข้อผิดพลาดขณะเรียกพนักงาน:', error);
                alert('เกิดข้อผิดพลาดขณะเรียกพนักงาน');
            } finally {
                this.openDialog = false; // ปิด dialog
                this.loading = false; // ปิดสถานะโหลด
            }
        },
        changeLanguage(lang) {
            this.$i18n.locale = lang;
            this.$store.commit('lang', lang);
            this.selectedLanguage = (lang == 'en') ? 'en' : 'th';
            window.location.reload(); // รีเฟรชหน้าเว็บ
        },
        async colorRestaurant() {
            HTTP.get('/showColor')
                .then((response) => {
                    if (response.data.successful === true) {
                        this.bg_color = response.data.color_code
                        this.beforeImage = response.data.logo_image
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        this.$router.push('/nametakeoutuser')
                    }

                })
        },
        async page(name) {
            this.title = name
            this.$emit('getTypeMenu', name)
        },
        async openTakeOutTable() {
            const idPage = {
                id: this.$route.params.id
            }

            this.$store.commit('detailTakeOutTablePage', idPage)
            let routeData = this.$router.resolve({
                name: 'takeOutUserTable'
            });
            window.open(routeData.href, '_blank');
        },
        async outTakeOutUser() {
            if (this.$route.name == 'takeOutUser') {
                this.$store.commit('clearCartListUserTakeOut')
                this.$router.push('/nametakeoutuser')
            }
            if (this.$route.name == 'orderOnlinePickUp') {
                this.$store.commit('clearCartOrderOnlineUser')
                this.$router.push('/nameorderonlinepickup')
            }
        }
    },
    mounted() {
        this.colorRestaurant()
        this.page(this.title)
    },
    watch: {
        table_type: function (val) {
            if (val === 'บุฟเฟ่') {
                this.cart_type = 'buffetuser/' + this.$route.params.id
            }
            if (val === 'ไม่บุฟเฟ่') {
                this.cart_type = 'singledishmealuser/' + this.$route.params.id
            }
            if (val === 'takeoutuser') {
                this.cart_type = 'takeoutuser/home'
            }
            if (val === 'orderonlinepickup') {
                this.cart_type = 'orderonlinepickup/home'
            }
        }
    }
}
</script>

<style scoped>

/* ไอคอนมุมขวาล่าง */
.floating-icon {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  padding: 10px;
  cursor: pointer;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.floating-icon:hover {
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.3);
}

.header_fixed {
    position: fixed;
    width: 100%;
    z-index: 2;
}

.color_header {
    background: linear-gradient(to top, #038cc1, #55c0e9)
}

.logo_header {
    width: 60px;
}

.logo_header>img {
    max-width: 100%;
}

.color_title_header {
    color: #fff;
}

.cart_all_header {
    position: relative;
    cursor: pointer;
}

.cart_all_header {
    margin-right: 15px;
}

.img_cart_header {
    width: 37px;
}

.img_cart_header>img {
    max-width: 100%;
}

.cart_number_header {
    position: absolute;
    top: -5px;
    right: -10px;
    border-radius: 50%;
    width: 15px;
    text-align: center;
    background: #ffffff;
    color: #038cc1;
    font-size: 12px;
}

.cursor_icon_header {
    cursor: pointer;
}
</style>
